// Angular
import '@angular/platform-browser';
import '@angular/platform-browser-dynamic';
import '@angular/core';
import '@angular/common';
// import '@angular/common/http';
import '@angular/router';

//ngx-translate
import '@ngx-translate/core';
import '@ngx-translate/http-loader';

// RxJS.
import 'rxjs';

//ngx-bootstrap
import 'ngx-bootstrap/datepicker';
import 'ngx-bootstrap/typeahead';

// Other vendors for example jQuery, Lodash or Bootstrap
// You can import js, ts, css, sass, ...

import 'jquery/dist/jquery';
